import type {
  LinerType,
  LinerTypeApi,
  LinerTypeFilters,
  LinerTypeFiltersUpdateApi,
  LinerTypes,
  LinerTypesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeLinerType = (linerType: LinerTypeApi): LinerType => ({
  ...linerType,
  id: linerType.codeId,
  label: linerType.codeDesc,
});

export const normalizeLinerTypes = (response: LinerTypesApi): LinerTypes => {
  const list = (response.items ?? []).map(normalizeLinerType);
  return {
    list,
    map: list.reduce(
      (acc, linerType) => {
        acc[String(linerType.id)] = linerType;
        return acc;
      },
      {} as LinerTypes['map'],
    ),
  };
};

export const normalizeLinerTypeFilters = (filters: Partial<LinerTypeFilters>): LinerTypeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
